import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import "./NavigationBar.css";
import logo from "../../img/logo.svg";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";
import { connect } from "react-redux";

const NavigationBar = (props) => {
  const { auth, profile, showToast } = props;
  const links = auth.uid ? (
    <SignedInLinks profile={profile} auth={auth} showToast={showToast} />
  ) : (
    <SignedOutLinks />
  );
  return (
    <div>
      <Navbar variant="dark" expand="lg">
        <Navbar.Brand href="/">
          <img src={logo} alt="logo" /> <p>Secureस्थल</p>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Item>
              <Nav.Link href="/intakeform1">Peer Counselling</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/selfevaluation">Self Evaluation</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/blogs">Blogs</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link href="/forums">Forums</Nav.Link>
            </Nav.Item> */}
            <Nav.Item>
              <Nav.Link href="/about">About Us</Nav.Link>
            </Nav.Item>
            {/* <NavDropdown title="Counselling" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">For You</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Story guided self-help
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>

          {links}
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
const mapStateToProps = (state) => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(NavigationBar);
